import React from "react";
import { useNavigate } from "react-router-dom";

import AgroTradeHeader from "../components/Header";
import LandingFooter from "../../landing/components/Footer";

const servicesList = [
    { id: "legal", title: "Услуга юридического сопровождения" },
    { id: "accounting", title: "Услуга бухгалтерского сопровождения" },
    { id: "marketing", title: "Услуга маркетингового сопровождения" },
    { id: "customs", title: "Услуга таможенного сопровождения" },
    { id: "sales", title: "Услуга по сбыту" },
    { id: "storage", title: "Услуг хранения" },
    { id: "ses_vet", title: "Услуга СЭС и Вэт" },
    { id: "packing", title: "Услуга упаковки" },
    { id: "logistics", title: "Услуга логистики" },
    { id: "planting", title: "Услуга посадки" },
    { id: "harvest", title: "Услуга сбора урожая" },
    { id: "counterparty", title: "Услуга контроля контрагентов" },
    { id: "acquiring", title: "Услуга эквайринга БВУ" },
    { id: "aero", title: "Услуга Агро аэронавигации" },
];

function Main() {
    const navigate = useNavigate();
    return (
        <div className="def_background min-h-screen flex flex-col">
            <AgroTradeHeader />

            <main className="flex-1">
                {/* Hero */}
                <section className="relative" id="banner">
                    <div className="h-[220px] md:h-[320px] w-full bg-[url('https://images.pexels.com/photos/158827/tractor-corn-agriculture-farm-158827.jpeg?auto=compress&cs=tinysrgb&w=1600')] bg-cover bg-center" />
                    <div className="absolute inset-0 bg-black/25" />
                    <div className="absolute inset-x-0 bottom-8 flex flex-col items-center gap-5 px-4">
                        <h1 className="text-white text-2xl md:text-3xl font-semibold drop-shadow-md">
                            AGROTRADE.KZ
                        </h1>
                        <div className="flex flex-wrap justify-center gap-4">
                            <button
                                onClick={() => navigate('/trade/wholesale')}
                                className="min-w-[170px] px-6 py-2.5 rounded-full bg-[#7AB30E] text-white text-xs md:text-sm font-semibold shadow hover:bg-[#65970c] transition text-center"
                            >
                                ОПТОВЫЕ ПРОДАЖИ
                            </button>
                            <button
                                onClick={() => navigate('/trade/export')}
                                className="min-w-[170px] px-6 py-2.5 rounded-full bg-[#7AB30E] text-white text-xs md:text-sm font-semibold shadow hover:bg-[#65970c] transition text-center"
                            >
                                ЭКСПОРТНЫЕ ПРОДАЖИ
                            </button>
                            <button
                                onClick={() => navigate('/trade/exchange')}
                                className="min-w-[170px] px-6 py-2.5 rounded-full bg-[#7AB30E] text-white text-xs md:text-sm font-semibold shadow hover:bg-[#65970c] transition text-center"
                            >
                                АГРО БИРЖА
                            </button>
                            <button
                                onClick={() => navigate('/trade/news')}
                                className="min-w-[170px] px-6 py-2.5 rounded-full bg-[#7AB30E] text-white text-xs md:text-sm font-semibold shadow hover:bg-[#65970c] transition text-center"
                            >
                                НОВОСТИ ПЛАТФОРМЫ
                            </button>
                        </div>
                    </div>
                </section>

                <div className="max-w-[1200px] mx-auto w-full px-4 py-10 lg:px-0">
                    {/* Услуги */}
                    <section id="services" className="mb-10">
                        <h2 className="text-xl md:text-2xl font-semibold mb-4">Услуги</h2>
                        <div className="grid gap-3 md:grid-cols-3 lg:grid-cols-4">
                            {servicesList.map((service) => (
                                <button
                                    key={service.id}
                                    onClick={() => navigate(`/trade/services?service=${service.id}`)}
                                    className="rounded-md border border-[#e5e7eb] bg-white px-3 py-3 text-xs md:text-sm text-left hover:border-[#147F26] hover:bg-[#147F26]/5 transition"
                                >
                                    {service.title}
                                </button>
                            ))}
                        </div>
                    </section>

                    {/* Госорганы */}
                    <section className="mb-10">
                        <h2 className="text-xl md:text-2xl font-semibold mb-4 uppercase">
                            Государственные органы
                        </h2>
                        <div className="grid gap-6 md:grid-cols-3">
                            {[
                                { name: "АКИМАТ", code: "akimat" },
                                { name: "АМАНАТ", code: "amanat" },
                                { name: "АКК", code: "akk" },
                            ].map((org) => (
                                <div
                                    key={org.code}
                                    className="rounded-xl border border-[#e5e7eb] bg-white overflow-hidden flex flex-col items-stretch"
                                >
                                    <div className="flex-1 flex items-center justify-center py-6">
                                        <div className="h-20 w-20 rounded-full bg-[#147F26]/10" />
                                    </div>
                                    <div className="border-t border-[#e5e7eb] py-2 text-center text-sm font-medium text-[#111827]">
                                        {org.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Новости */}
                    <section id="news" className="mb-10">
                        <h2 className="text-xl md:text-2xl font-semibold mb-4 uppercase">
                            Новости платформы
                        </h2>
                        <div className="grid gap-4 md:grid-cols-3">
                            {[1, 2, 3].map((id) => (
                                <article
                                    key={id}
                                    className="bg-white rounded-xl overflow-hidden border border-[#e5e7eb] hover:shadow-md transition"
                                >
                                    <div className="h-36 bg-[url('https://images.pexels.com/photos/1595104/pexels-photo-1595104.jpeg?auto=compress&cs=tinysrgb&w=1200')] bg-cover bg-center" />
                                </article>
                            ))}
                        </div>
                    </section>
                </div>
            </main>

            <LandingFooter />
        </div>
    );
}

export default Main;
